import { ReactElement } from 'react';

import { TypographyProps, Typography } from '@beeline/design-system-react/extracted-styles';

import cn from 'classnames';

import styles from './styles.module.scss';

export interface StyledLinkProps extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  /** Route to navigate to */
  to?: string;
  /** Class name to apply directly to the text content */
  typographyClassName?: string;
  /** Text content variant */
  variant?: TypographyProps['variant'];
  /** Do not use <p> wrapper */
  noWrapper?: boolean;
  /** Whether to disable visited highlight or not */
  disableVisited?: boolean;
  /** Disable text-underline */
  disableTextDecoration?: boolean;
  /** Whether to disabled link or not */
  disabled?: boolean;
  /** Specifies that the redirect will be opened in a new tab. */
  openInNewTab?: boolean;
}

/**
 * @description StyledLink component
 */
export function StyledLink({
  children,
  className,
  disableTextDecoration,
  disableVisited,
  disabled,
  noWrapper,
  onClick,
  openInNewTab = false,
  to,
  typographyClassName,
  variant = 'body3',
  ...rest
}: StyledLinkProps): ReactElement {
  const content = noWrapper ? (
    children
  ) : (
    <Typography variant={variant} className={cn(styles.text, typographyClassName)}>
      {children}
    </Typography>
  );

  const linkClassname = cn(
    styles.link,
    {
      [styles.disabled!]: disabled,
      [styles.disableVisited!]: disableVisited,
      [styles.enabledTextDecoration!]: !disableTextDecoration,
    },
    className,
  );

  return (
    <a
      {...(openInNewTab ? { rel: 'noreferrer', target: '_blank' } : {})}
      {...rest}
      className={linkClassname}
      href={to}
      onClick={onClick}
    >
      {content}
    </a>
  );
}
